import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Default third-party payer customer ID.
 */
export const schema = z.number().int().positive().nullable();

export type DefaultPayer = z.infer<typeof schema>;

export const definition = define({
  key: 'default_payer',
  schema,
  label: 'Default Payer',
  description:
    "The default payer for moves created through the portal or API. For now, we have to select this from the full list of customers. Please be sure you have selected the correct customer before you save. To remove the default payer, select 'None'.",
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.THIRD_PARTY_PAYER.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER, LEVELS.WORKFLOWSET, LEVELS.RATERULEGROUP],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: null,
});
